import { Badge, Flex, Text } from "@radix-ui/themes";

import type {
  MarketStatusPillColor,
  MarketStatusPillData,
} from "./marketStatusPill.utils";

export type MarketStatusPillPresentationProps = MarketStatusPillData;

const RADIX_COLORS: Record<MarketStatusPillColor, "green" | "gray" | "orange"> =
  {
    green: "green",
    gray: "gray",
    amber: "orange",
  };

export const MarketStatusPillPresentation = ({
  label,
  color,
}: MarketStatusPillPresentationProps) => (
  <Flex asChild align="center" gap="1">
    <Badge variant="soft" color={RADIX_COLORS[color]}>
      <span
        aria-hidden="true"
        className="size-1.5 rounded-full [background-color:currentColor]"
      />
      <Text size="1">{label}</Text>
    </Badge>
  </Flex>
);
